import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { FIELD_OPS_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { FeedbackListPage } from '@/features/feedback/pages/FeedbackListPage';
import { feedbackSearchSchema } from '@/features/feedback/types/feedback.types';

export const Route = createFileRoute('/_auth/feedback/list/')({
  beforeLoad: () => requirePermission(FIELD_OPS_PERMISSIONS.FEEDBACK_VIEW),
  validateSearch: feedbackSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Feedbacks">
      <Suspense fallback={<PageLoader />}>
        <FeedbackListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
